import {TrustBlockContent} from '../TrustBlockContent'

export const TopRated = () => {
  return <TrustBlockContent prefix="topRated" defaultText="Thousands of reviews averaging 4.9 stars" />
}
